import { useLocale } from "../i18n";
import "../styles/invitation-email.css";

export function InvitationContactChoice({ email, disabled, existingLabel, onChange }: { email: boolean; disabled: boolean; existingLabel: string; onChange: (email: boolean) => void }) {
  const { w } = useLocale();
  return <fieldset className="invitation-contact-choice" disabled={disabled}><legend>{w("طريقة تحديد المستلم", "Recipient method")}</legend>
    <button type="button" className="secondary" aria-pressed={!email} onClick={() => onChange(false)}>{existingLabel}</button>
    <button type="button" className="secondary" aria-pressed={email} onClick={() => onChange(true)}>{w("الإيميل", "Email")}</button>
  </fieldset>;
}
